module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "do-table do-table__user-employments",
    class: {
      'do-table__user-employments--import': _vm.isSalaryIntegrationActive
    }
  }, [_c('thead', [_c('th', {
    staticClass: "do-table__toggle-all",
    on: {
      "click": function($event) {
        return _vm.$emit('toggleAllEmployments')
      }
    }
  }, [(_vm.selectedEmploymentIds.length === 0) ? [_vm._v("\n      " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n    ")] : [_vm._v("\n      " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n    ")]], 2), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), _c('th', [_vm._v("Organisation")]), _vm._v(" "), _c('th', [_vm._v("Skabelon")]), _vm._v(" "), _c('th', {
    staticClass: "td-subsalary"
  }, [_vm._v("Vikarløn")]), _vm._v(" "), _c('th', [_vm._v("Std. Lønkode")]), _vm._v(" "), _c('th', [_vm._v("Std. Omkostningsted")])]), _vm._v(" "), _c('tbody', {
    ref: "d-b"
  }, [_vm._l((_vm.filteredUsers), function(user) {
    return (_vm.isSalaryIntegrationActive) ? [_c('tbody', {
      key: 'user-' + user.id,
      staticClass: "user-group"
    }, [_vm._l((user.v_employments), function(employment) {
      return _c('tr', {
        key: 'employment-' + employment.id,
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.setTheEditUser(user)
          }
        }
      }, [_c('td', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$emit('toggleEmployment', employment)
          }
        }
      }, [_c('div', {
        staticClass: "d-checkbox",
        class: {
          'd-checkbox--active': _vm.isEmploymentSelected(employment.id)
        },
        attrs: {
          "title": "Vælg/fravælg ansættelse"
        }
      })]), _vm._v(" "), _c('td', {
        class: {
          'td-organisation': !employment.employment_template_id
        }
      }, [_c('strong', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v(_vm._s(employment.source_title ? employment.source_title : employment.title))]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v(_vm._s(employment.organisation))]), _vm._v(" "), _c('td', [(employment.employment_template_id) ? _c('span', {
        staticClass: "d-tag d-tag--inline",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$emit('editEmployment', {
              user: user,
              employment: employment
            })
          }
        }
      }, [_vm._v("\n              " + _vm._s(employment.title) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "td-subsalary"
      }, [(employment.manual_salary) ? _c('span', {
        staticClass: "do-pill do-pill--small do-custom-pill do-pill--yellow "
      }, [_vm._v("Vikarløn\n          ")]) : _vm._e()]), _vm._v(" "), _c('td', [(employment.manual_salary) ? _c('span', {
        staticClass: "do-pill do-pill--small do-custom-pill"
      }, [_vm._v("\n          " + _vm._s(_vm.getDefaultSalaryCodeName(employment.salary_code_id)) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('td', [(employment.manual_salary && employment.default_omkostningssted) ? _c('span', {
        staticClass: "do-pill do-pill--small do-custom-pill"
      }, [_vm._v("\n          " + _vm._s(_vm.getCostCenterName(employment.default_omkostningssted)) + "\n        ")]) : _vm._e()])])
    }), _vm._v(" "), (user.v_employments.length === 0) ? _c('tr', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setTheEditUser(user)
        }
      }
    }, [_c('td'), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "5"
      }
    })]) : _vm._e()], 2)] : _vm._l((_vm.filteredUsers), function(user) {
      return _c('tr', {
        key: user.id
      }, [_c('td', {
        attrs: {
          "colspan": "1"
        }
      }), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
        staticClass: "d-tags",
        attrs: {
          "colspan": "5"
        }
      }, [_vm._l((user.v_employments), function(employment) {
        return _c('div', {
          key: employment.id,
          staticClass: "d-tag",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.$emit('toggleEmployment', employment)
            }
          }
        }, [_c('span', {
          class: {
            'd-checkbox': true, 'd-checkbox--active': _vm.isEmploymentSelected(employment.id)
          }
        }), _vm._v("\n          " + _vm._s(employment.title) + "\n          "), (employment.organisation) ? _c('div', {
          staticClass: "d-tag d-tag--inner"
        }, [_vm._v(_vm._s(employment.organisation))]) : _vm._e(), _vm._v(" "), (employment.manual_salary) ? _c('div', {
          staticClass: "do-pill do-pill--small do-pill--yellow"
        }, [_vm._v("Vikarløn")]) : _vm._e()])
      }), _vm._v(" "), (user.v_employments.length === 0 && _vm.isShowNoEmploymentsText) ? _c('p', {
        staticClass: "italic font-small"
      }, [_vm._v("Ingen\n          ansættelser")]) : _vm._e()], 2)])
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-674316b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalarySettingsUsersOpusTable.vue
// module id = 1688
// module chunks = 1